module.exports = __webpack_public_path__ + "static/media/JR BIPC(20-06-2026).a3e34844.xlsx";